const { GET_EMPANELMENT_PROCESS } = require("src/actions/types");

const initialState = { EmpanelmentProcessList: [] };

const EmpanelmentProcessReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EMPANELMENT_PROCESS:
      return {
        ...state,
        EmpanelmentProcessList: payload,
      };
    default:
      return state;
  }
};

export { EmpanelmentProcessReducer };
